import {Routes} from '@angular/router';
import {MainViewComponent} from './main-view/main-view.component';
import * as moment from 'moment';

export const rootRouterConfig: Routes = [
  {
    path: ':calendar',
    component: MainViewComponent,
  },
  {
    path: '**',
    redirectTo: `/${moment(new Date()).format('YYYY-MM-DD')}`,
    pathMatch: 'full'
  }
];

